import * as i0 from '@angular/core';
import { EventEmitter, ElementRef, Component, Input, Output, ViewChildren, ViewChild, NgModule } from '@angular/core';
import * as i3 from 'abs-ngx-library/src/lib/loyalty-card';
import { LoyaltyCardAlV1Component, LoyaltyCardModule } from 'abs-ngx-library/src/lib/loyalty-card';
import { BehaviorSubject } from 'rxjs';
import * as i1 from 'abs-ngx-library/src/lib/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

const _c0 = ["nextRedesignButton"];
const _c1 = ["prevRedesignButton"];
const _c2 = a0 => ({ "d-none": a0 });
const _c3 = a0 => ({ "svg-btn-slick-prev--disabled": a0 });
const _c4 = a0 => ({ "svg-btn-slick-next--disabled": a0 });
function DealsCarouselComponent_div_0_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 17);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.carouselData == null ? null : ctx_r1.carouselData.appCtaProps == null ? null : ctx_r1.carouselData.appCtaProps.ctaText);
} }
function DealsCarouselComponent_div_0_div_1_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.carouselData == null ? null : ctx_r1.carouselData.webCtaProps == null ? null : ctx_r1.carouselData.webCtaProps.ctaText);
} }
function DealsCarouselComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "h2", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 14)(5, "a", 15);
    i0.ɵɵlistener("click", function DealsCarouselComponent_div_0_div_1_Template_a_click_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onClickOfViewAll()); });
    i0.ɵɵtemplate(6, DealsCarouselComponent_div_0_div_1_ng_container_6_Template, 3, 1, "ng-container", 16)(7, DealsCarouselComponent_div_0_div_1_ng_template_7_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const webCta_r3 = i0.ɵɵreference(8);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.carouselData == null ? null : ctx_r1.carouselData.title);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r1.carouselData == null ? null : ctx_r1.carouselData.appCtaProps == null ? null : ctx_r1.carouselData.appCtaProps.ctaText) && (ctx_r1.carouselData == null ? null : ctx_r1.carouselData.appCtaProps == null ? null : ctx_r1.carouselData.appCtaProps.ctaText) !== "")("ngIfElse", webCta_r3);
} }
function DealsCarouselComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.carouselData == null ? null : ctx_r1.carouselData.subTitle, " ");
} }
function DealsCarouselComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "div", 19)(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 21);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 22)(7, "a", 23);
    i0.ɵɵlistener("click", function DealsCarouselComponent_div_0_div_3_Template_a_click_7_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onClickOfViewAll()); });
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 24, 1);
    i0.ɵɵlistener("keyup.enter", function DealsCarouselComponent_div_0_div_3_Template_button_keyup_enter_9_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setAdaAnnouncement("Previous set of items shown")); })("click", function DealsCarouselComponent_div_0_div_3_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setAdaAnnouncement("Previous set of items shown")); });
    i0.ɵɵelement(11, "span", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 26, 2);
    i0.ɵɵlistener("keyup.enter", function DealsCarouselComponent_div_0_div_3_Template_button_keyup_enter_12_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setAdaAnnouncement("Next set of items shown")); })("click", function DealsCarouselComponent_div_0_div_3_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setAdaAnnouncement("Next set of items shown")); });
    i0.ɵɵelement(14, "span", 27);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.carouselData == null ? null : ctx_r1.carouselData.title);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.carouselData == null ? null : ctx_r1.carouselData.subTitle);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (ctx_r1.carouselData == null ? null : ctx_r1.carouselData.appCtaProps == null ? null : ctx_r1.carouselData.appCtaProps.ctaText) && (ctx_r1.carouselData == null ? null : ctx_r1.carouselData.appCtaProps == null ? null : ctx_r1.carouselData.appCtaProps.ctaText) !== "" ? ctx_r1.carouselData == null ? null : ctx_r1.carouselData.appCtaProps == null ? null : ctx_r1.carouselData.appCtaProps.ctaText : ctx_r1.carouselData == null ? null : ctx_r1.carouselData.webCtaProps == null ? null : ctx_r1.carouselData.webCtaProps.ctaText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2, !ctx_r1.showRedesignButtons))("disabled", ctx_r1.isPrevButtonDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c3, ctx_r1.isPrevButtonDisabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2, !ctx_r1.showRedesignButtons))("disabled", ctx_r1.isNextButtonDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c4, ctx_r1.isNextButtonDisabled));
} }
function DealsCarouselComponent_div_0_ng_container_5_loyalty_card_al_v1_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "loyalty-card-al-v1", 29);
    i0.ɵɵlistener("refreshTitleEvent", function DealsCarouselComponent_div_0_ng_container_5_loyalty_card_al_v1_1_Template_loyalty_card_al_v1_refreshTitleEvent_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.refreshTitle($event)); })("refreshSlickCarousel", function DealsCarouselComponent_div_0_ng_container_5_loyalty_card_al_v1_1_Template_loyalty_card_al_v1_refreshSlickCarousel_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.refreshSlickCarousel($event)); })("openRightFlyoutEvent", function DealsCarouselComponent_div_0_ng_container_5_loyalty_card_al_v1_1_Template_loyalty_card_al_v1_openRightFlyoutEvent_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.openRightFlyoutEvent($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const coupon_r7 = ctx_r5.$implicit;
    const i_r8 = ctx_r5.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cardType", "coupon")("couponDisplayFormat", "carousel")("cardData", coupon_r7)("cardIndex", i_r8)("logoProps", ctx_r1.logoProps)("isP13nCoupon", ctx_r1.isP13nCoupon)("configObj", ctx_r1.configObj)("isLoyaltyCardCarouselRedesignDisabled", ctx_r1.isLoyaltyCardCarouselRedesignDisabled);
} }
function DealsCarouselComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DealsCarouselComponent_div_0_ng_container_5_loyalty_card_al_v1_1_Template, 1, 8, "loyalty-card-al-v1", 28);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const coupon_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", coupon_r7["offerId"] || coupon_r7["couponID"]);
} }
function DealsCarouselComponent_div_0_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.adaAnnouncement, " ");
} }
function DealsCarouselComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, DealsCarouselComponent_div_0_div_1_Template, 9, 3, "div", 5)(2, DealsCarouselComponent_div_0_div_2_Template, 2, 1, "div", 6)(3, DealsCarouselComponent_div_0_div_3_Template, 15, 17, "div", 7);
    i0.ɵɵelementStart(4, "div", 8);
    i0.ɵɵtemplate(5, DealsCarouselComponent_div_0_ng_container_5_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, DealsCarouselComponent_div_0_span_6_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isLoyaltyCardCarouselRedesignDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isLoyaltyCardCarouselRedesignDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isLoyaltyCardCarouselRedesignDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.coupons)("ngForTrackBy", ctx_r1.trackFn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isAdaAnnouncementEnabled);
} }
class DealsCarouselComponent {
    constructor(elementRef, _aemService, _carouselService) {
        this.elementRef = elementRef;
        this._aemService = _aemService;
        this._carouselService = _carouselService;
        this.logoProps = {};
        this.coupons = [];
        this.configObj = {
            appName: '',
            programType: ''
        };
        this.openFlyOutEvent = new EventEmitter();
        this.viewAllClickEvent = new EventEmitter();
        this._childComponentsReady = new BehaviorSubject(false);
        this.disableSlickUnifiedBtnUI = false;
        this.isP13nCoupon = false;
        this.isLoyaltyCardCarouselRedesignDisabled = true;
        this.adaAnnouncement = '';
        this.isAdaAnnouncementEnabled = false;
        this.showRedesignButtons = true;
        this.isNextButtonDisabled = false;
        this.isPrevButtonDisabled = false;
    }
    ngOnInit() {
        this.isLoyaltyCardCarouselRedesignDisabled = this._aemService.getFeatureFlagByNameDisable('isLoyaltyCardCarouselRedesignDisabled');
        this.wrapper = this.elementRef.nativeElement.parentNode?.parentNode;
    }
    ngOnChanges() {
        this.coupons = this.carouselData?.dealsInfo;
        if (this.coupons && this.coupons.length > 0) {
            this._childComponentsReady.next(true);
        }
    }
    ngAfterViewInit() {
        this._childComponentsReady.subscribe((next) => {
            if (next !== true) {
                return;
            }
            if (this.coupons.length === 0) {
                return;
            }
            // detect changes when coupon card is loaded
            if (this.couponCardChildComponents.length > 0) {
                this.initSlick();
                // this._carouselService.setAriaLabelForCouponCarousel(
                //   this.elementRef.nativeElement,
                //   this.couponsCarousel.carouselTitle
                // );
            }
            else {
                this.couponCardChildComponents.changes.subscribe(() => {
                    this.initSlick();
                    // this._carouselService.setAriaLabelForCouponCarousel(
                    //   this.elementRef.nativeElement,
                    //   this.couponsCarousel.carouselTitle
                    // );
                });
            }
            if (window['AB']['DATALAYER']) {
                window['AB']['DATALAYER'].trackP13nCarousel(this.wrapper, this.coupons, 'load');
            }
        });
    }
    initSlick() {
        const elementRef = this.elementRef.nativeElement;
        const activeSlidesL2 = {
            "320": 1,
            "695": 2,
            "767": 1,
            "920": 2,
            "1280": 3,
        };
        const activeSlides = {
            "320": 1,
            "660": 2,
            "767": 2,
            "970": 3,
            "1260": 4,
        };
        const activeSlidesPdp = {
            "660": 2,
            "767": 1,
            "1260": 2,
        };
        if (this.configObj?.appName === 'FreshPass') {
            activeSlides["1260"] = 3;
        }
        const breakpointsL2 = [
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: activeSlidesL2["320"],
                    slidesToScroll: activeSlidesL2["320"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 695,
                settings: {
                    slidesToShow: activeSlidesL2["695"],
                    slidesToScroll: activeSlidesL2["695"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: activeSlidesL2["767"],
                    slidesToScroll: activeSlidesL2["767"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: activeSlidesL2["920"],
                    slidesToScroll: activeSlidesL2["920"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: activeSlidesL2["1280"],
                    slidesToScroll: activeSlidesL2["1280"],
                    dots: false,
                    arrows: true,
                },
            },
        ];
        const breakpoints = [
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: activeSlides["320"],
                    slidesToScroll: activeSlides["320"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: activeSlides["660"],
                    slidesToScroll: activeSlides["660"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: activeSlides["767"],
                    slidesToScroll: activeSlides["767"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 970,
                settings: {
                    slidesToShow: activeSlides["970"],
                    slidesToScroll: activeSlides["970"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 1260,
                settings: {
                    slidesToShow: activeSlides["1260"],
                    slidesToScroll: activeSlides["1260"],
                    dots: false,
                    arrows: true,
                },
            },
        ];
        const breakpointsPdp = [
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: activeSlidesPdp["660"],
                    slidesToScroll: activeSlidesPdp["660"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: activeSlidesPdp["767"],
                    slidesToScroll: activeSlidesPdp["767"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 1260,
                settings: {
                    slidesToShow: activeSlidesPdp["1260"],
                    slidesToScroll: activeSlidesPdp["1260"],
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 1920,
                settings: {
                    slidesToShow: activeSlidesPdp["1260"],
                    slidesToScroll: activeSlidesPdp["1260"],
                    dots: false,
                    arrows: true,
                },
            },
        ];
        const pageTemplate = $("meta[name=template]")
            ? $("meta[name=template]").attr("content")
            : "";
        const pdpPageTemplates = ["unified-productdetails-page", "nextgen-pdp", "product-detail-page"];
        if ($(elementRef).find("#carousel-coupons").hasClass("slick-initialized")) {
            $(elementRef).find("#carousel-coupons").slick("unslick");
            $(elementRef).find("#carousel-coupons").removeClass("slick-initialized");
        }
        let arrow;
        $(elementRef)
            .find("#carousel-coupons")
            .not(".slick-initialized")
            .on('init', (event, slick) => {
            if (!this.isLoyaltyCardCarouselRedesignDisabled) {
                // Handle show/disable redesign nav buttons, add slick carousel classes, set the max width of slick track 
                // and then hit next on observable for ada specific changes for redesign
                this.handleShowingRedesignNavButtons();
                this._carouselService.slickChanges.next({});
            }
        })
            .slick({
            lazyLoad: "ondemand",
            tail: true,
            dots: false,
            infinite: false,
            cssEase: "linear",
            speed: 300,
            centerMode: false,
            variableWidth: true,
            variableHeight: true,
            mobileFirst: true,
            accessibility: true,
            swipe: true,
            swipeToSlide: false,
            // prevArrow: false,//Added
            ...(this.disableSlickUnifiedBtnUI === false && {
                nextArrow: !this.isLoyaltyCardCarouselRedesignDisabled ? this.nextRedesignButtonRef.nativeElement :
                    '<button type="button" aria-label="Go to the next slide" class="slick-next coupons-carousel-module__next-btn"></button>',
            }),
            ...(this.disableSlickUnifiedBtnUI === false && {
                prevArrow: !this.isLoyaltyCardCarouselRedesignDisabled ? this.prevRedesignButtonRef.nativeElement :
                    '<button type="button" aria-label="Go to the previous slide" class="slick-prev coupons-carousel-module__prev-btn"></button>',
            }),
            responsive: pageTemplate === "unified-dynamic-l2-page"
                ? breakpointsL2
                : pdpPageTemplates.indexOf(pageTemplate) > -1
                    ? breakpointsPdp
                    : breakpoints,
        })
            .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            if (nextSlide !== 0) {
                $("#carousel-coupons .slick-prev").removeClass("mask");
            }
            else {
                $("#carousel-coupons .slick-prev").addClass("mask");
            }
            if (this.isCarouselRedesignDisabled) {
                if (currentSlide < nextSlide) {
                    // Next Button pressed
                    const newSlickIndex = Number($(".slick-active", $(elementRef)).last().attr("data-slick-index")) + 1;
                    const focusSlide = $('.slick-list .slick-slide[data-slick-index="' +
                        newSlickIndex +
                        '"] .coupon-carousel-title', $(elementRef));
                    if (focusSlide) {
                        setTimeout(function () {
                            focusSlide.eq(0).html(focusSlide.eq(0).html()).focus();
                        }, 300);
                    }
                    arrow = 'next';
                }
                else {
                    // Prev Button pressed
                    const newSlickIndex = Number($(".slick-active", $(elementRef)).first().attr("data-slick-index")) - 1;
                    const focusSlide = $('.slick-list .slick-slide[data-slick-index="' +
                        newSlickIndex +
                        '"] .coupon-carousel-title', $(elementRef));
                    if (focusSlide) {
                        setTimeout(function () {
                            focusSlide.eq(0).html(focusSlide.eq(0).html()).focus();
                        }, 300);
                    }
                    arrow = 'prev';
                }
            }
        })
            .on('afterChange', () => {
            if (!this.isLoyaltyCardCarouselRedesignDisabled) {
                this.handleShowingRedesignNavButtons();
                this._carouselService.slickChanges.next({});
            }
            setTimeout(() => {
                switch (arrow) {
                    case 'next':
                        if (window['AB']['DATALAYER']) {
                            window['AB']['DATALAYER'].trackP13nCarousel(this.wrapper, this.coupons, 'forward');
                        }
                        break;
                    case 'prev':
                        if (window['AB']['DATALAYER']) {
                            window['AB']['DATALAYER'].trackP13nCarousel(this.wrapper, this.coupons, 'back');
                        }
                        break;
                    default:
                        break;
                }
            }, 0);
        });
        $("#carousel-coupons .slick-prev").addClass("mask");
    }
    setAdaAnnouncement(announcement) {
        clearTimeout(this.announcementTimeout);
        this.isAdaAnnouncementEnabled = true;
        setTimeout(() => { this.adaAnnouncement = announcement; }, 100);
        this.announcementTimeout = setTimeout(() => {
            this.adaAnnouncement = '';
            this.isAdaAnnouncementEnabled = false;
        }, 500);
    }
    handleShowingRedesignNavButtons() {
        this.showRedesignButtons = (window.innerWidth >= 768);
        this.isNextButtonDisabled = this.nextRedesignButtonRef.nativeElement.classList.contains('slick-disabled');
        this.isPrevButtonDisabled = this.prevRedesignButtonRef.nativeElement.classList.contains('slick-disabled');
    }
    refreshSlickCarousel(slideIndex) {
    }
    trackFn(ind, el) {
        return ind;
    }
    refreshTitle(updatedCoupon) {
    }
    openRightFlyoutEvent(couponData) {
        this.openFlyOutEvent.emit(couponData);
    }
    onClickOfViewAll() {
        if (this.configObj.appName === 'weeklyAdPzn') {
            this.viewAllClickEvent.emit();
        }
        else if (this.carouselData?.appName == 'deals-carousel-targetted' && this.carouselData?.webCtaProps?.ctaLink) {
            if (this.carouselData?.webCtaProps?.openNewTab == "true") {
                window.open(this.carouselData?.webCtaProps?.ctaLink, '_blank');
            }
            else {
                window.location.href = this.carouselData?.webCtaProps?.ctaLink;
            }
        }
    }
    static { this.ɵfac = function DealsCarouselComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DealsCarouselComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AemService), i0.ɵɵdirectiveInject(i1.LoyaltyCarouselService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DealsCarouselComponent, selectors: [["deals-carousel"]], viewQuery: function DealsCarouselComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5, ElementRef);
            i0.ɵɵviewQuery(_c1, 5, ElementRef);
            i0.ɵɵviewQuery(LoyaltyCardAlV1Component, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nextRedesignButtonRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.prevRedesignButtonRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.couponCardChildComponents = _t);
        } }, inputs: { carouselData: "carouselData", logoProps: "logoProps", configObj: "configObj" }, outputs: { openFlyOutEvent: "openFlyOutEvent", viewAllClickEvent: "viewAllClickEvent" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["webCta", ""], ["prevRedesignButton", ""], ["nextRedesignButton", ""], ["class", "slick-coupon-carousel carousel-container coupons-carousel slick-coupon-carousel-v2", 4, "ngIf"], [1, "slick-coupon-carousel", "carousel-container", "coupons-carousel", "slick-coupon-carousel-v2"], ["class", "carousel-header-wrapper", 4, "ngIf"], [4, "ngIf"], ["class", "carousel-nav d-flex align-items-start py-2", 4, "ngIf"], ["id", "carousel-coupons", 1, "coupons"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["role", "status", "aria-atomic", "true", "aria-live", "assertive", "class", "sr-only", 4, "ngIf"], [1, "carousel-header-wrapper"], [1, "carousel-header-text-wrapper"], [1, "carousel-header-text", "m0"], [1, "carousel-headers-link-wrapper"], [1, "carousel-header-link", 3, "click"], [4, "ngIf", "ngIfElse"], ["aria-hidden", "true", 1, "carousel-header-link-text"], [1, "carousel-nav", "d-flex", "align-items-start", "py-2"], [1, "d-flex", "flex-column", "justify-content-center", "align-self-stretch", "flex-grow-1"], ["role", "heading", 1, "carousel-nav__header-title", "color-neutral-90"], [1, "body-text-xs"], [1, "d-flex", "carousel-nav__controls-wrapper", "align-items-center"], [1, "link-sm", "links__action", 3, "click"], ["type", "button", "aria-label", "View previous items", 1, "btn", "slick-redesign-prev", "btn-secondary", "btn-circle--md", "ml-3", "mr-3", 3, "keyup.enter", "click", "ngClass", "disabled"], [1, "svg-icon", "svg-btn-slick-prev", 3, "ngClass"], ["type", "button", "aria-label", "View next items", 1, "btn", "slick-redesign-next", "btn-secondary", "btn-circle--md", 3, "keyup.enter", "click", "ngClass", "disabled"], [1, "svg-icon", "svg-btn-slick-next", 3, "ngClass"], ["class", "carousel-coupon-card", 3, "cardType", "couponDisplayFormat", "cardData", "cardIndex", "filterSource", "carouselSection", "couponsCarouselItem", "logoProps", "isP13nCoupon", "configObj", "isLoyaltyCardCarouselRedesignDisabled", "refreshTitleEvent", "refreshSlickCarousel", "openRightFlyoutEvent", 4, "ngIf"], [1, "carousel-coupon-card", 3, "refreshTitleEvent", "refreshSlickCarousel", "openRightFlyoutEvent", "cardType", "couponDisplayFormat", "cardData", "cardIndex", "filterSource", "carouselSection", "couponsCarouselItem", "logoProps", "isP13nCoupon", "configObj", "isLoyaltyCardCarouselRedesignDisabled"], ["role", "status", "aria-atomic", "true", "aria-live", "assertive", 1, "sr-only"]], template: function DealsCarouselComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, DealsCarouselComponent_div_0_Template, 7, 6, "div", 3);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.coupons == null ? null : ctx.coupons.length) > 0);
        } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.LoyaltyCardAlV1Component] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DealsCarouselComponent, [{
        type: Component,
        args: [{ selector: 'deals-carousel', template: "<div *ngIf=\"coupons?.length>0\" class=\"slick-coupon-carousel carousel-container coupons-carousel slick-coupon-carousel-v2\">\n     <div *ngIf=\"isLoyaltyCardCarouselRedesignDisabled\" class=\"carousel-header-wrapper\">\n        <div class=\"carousel-header-text-wrapper\">\n            <h2 class=\"carousel-header-text m0\">{{carouselData?.title}}</h2>\n        </div>\n        <div class=\"carousel-headers-link-wrapper\">\n            <a class=\"carousel-header-link\" (click)=\"onClickOfViewAll()\">\n                <ng-container *ngIf=\"carouselData?.appCtaProps?.ctaText && carouselData?.appCtaProps?.ctaText !== ''; else webCta\">\n                    <span class=\"carousel-header-link-text\" aria-hidden=\"true\">{{carouselData?.appCtaProps?.ctaText}}</span>\n                </ng-container>\n                <ng-template #webCta>\n                    <span class=\"carousel-header-link-text\" aria-hidden=\"true\">{{carouselData?.webCtaProps?.ctaText}}</span>\n                </ng-template>\n            </a>\n        </div>\n    </div>\n    <div *ngIf=\"isLoyaltyCardCarouselRedesignDisabled\">\n        {{carouselData?.subTitle}}\n    </div>\n    <div *ngIf=\"!isLoyaltyCardCarouselRedesignDisabled\" class=\"carousel-nav d-flex align-items-start py-2\">\n        <div class=\"d-flex flex-column justify-content-center align-self-stretch flex-grow-1\">\n            <span role=\"heading\" class=\"carousel-nav__header-title color-neutral-90\">{{carouselData?.title}}</span>\n            <span class=\"body-text-xs\">{{carouselData?.subTitle}}</span>\n        </div>\n        <div class=\"d-flex carousel-nav__controls-wrapper align-items-center\">\n            <a (click)=\"onClickOfViewAll()\" class=\"link-sm links__action\"> \n            {{(carouselData?.appCtaProps?.ctaText && carouselData?.appCtaProps?.ctaText !== '') ?\n                carouselData?.appCtaProps?.ctaText :\n                carouselData?.webCtaProps?.ctaText\n            }}  \n        </a>\n        <button [ngClass]=\"{'d-none':!showRedesignButtons}\" #prevRedesignButton [disabled]=\"isPrevButtonDisabled\" (keyup.enter)=\"setAdaAnnouncement('Previous set of items shown')\" \n        (click)=\"setAdaAnnouncement('Previous set of items shown')\" type=\"button\" class=\"btn slick-redesign-prev btn-secondary btn-circle--md ml-3 mr-3\"\n            aria-label=\"View previous items\">\n            <span [ngClass]=\"{'svg-btn-slick-prev--disabled':isPrevButtonDisabled}\" class=\"svg-icon svg-btn-slick-prev \"></span>\n        </button>\n        <button [ngClass]=\"{'d-none':!showRedesignButtons}\" #nextRedesignButton [disabled]=\"isNextButtonDisabled\" (keyup.enter)=\"setAdaAnnouncement('Next set of items shown')\" \n        (click)=\"setAdaAnnouncement('Next set of items shown')\" type=\"button\" \n        class=\"btn slick-redesign-next btn-secondary btn-circle--md\"\n            aria-label=\"View next items\">\n            <span [ngClass]=\"{'svg-btn-slick-next--disabled':isNextButtonDisabled}\" class=\"svg-icon svg-btn-slick-next \"></span>\n        </button>\n        </div>\n    </div>\n    \n        <div id=\"carousel-coupons\" class=\"coupons\">\n            <ng-container *ngFor=\"let coupon of coupons; trackBy: trackFn; let i=index\">\n                <loyalty-card-al-v1 *ngIf=\"((coupon['offerId'] || coupon['couponID']))\" \n                                        [cardType]=\"'coupon'\" \n                                        [couponDisplayFormat]=\"'carousel'\" \n                                        [cardData]=\"coupon\" \n                                        [cardIndex]=\"i\"\n                                        [filterSource]=\"\"\n                                        [carouselSection]=\"\"\n                                        [couponsCarouselItem]=\"\"\n                                        class=\"carousel-coupon-card\" \n                                        (refreshTitleEvent)=\"refreshTitle($event)\"\n                                        (refreshSlickCarousel)=\"refreshSlickCarousel($event)\" \n                                        [logoProps]=\"logoProps\"\n                                        [isP13nCoupon]=\"isP13nCoupon\"\n                                        [configObj]=\"configObj\"\n                                        (openRightFlyoutEvent)=\"openRightFlyoutEvent($event)\"\n                                        [isLoyaltyCardCarouselRedesignDisabled] = \"isLoyaltyCardCarouselRedesignDisabled\"\n                                        >\n                </loyalty-card-al-v1>\n            </ng-container>\n        </div>\n        <span role=\"status\" aria-atomic=\"true\" aria-live=\"assertive\" class=\"sr-only\" *ngIf=\"isAdaAnnouncementEnabled\">\n            {{adaAnnouncement}}\n        </span>\n</div>\n" }]
    }], () => [{ type: i0.ElementRef }, { type: i1.AemService }, { type: i1.LoyaltyCarouselService }], { carouselData: [{
            type: Input
        }], logoProps: [{
            type: Input
        }], configObj: [{
            type: Input
        }], openFlyOutEvent: [{
            type: Output
        }], viewAllClickEvent: [{
            type: Output
        }], couponCardChildComponents: [{
            type: ViewChildren,
            args: [LoyaltyCardAlV1Component]
        }], nextRedesignButtonRef: [{
            type: ViewChild,
            args: ['nextRedesignButton', { static: false, read: ElementRef }]
        }], prevRedesignButtonRef: [{
            type: ViewChild,
            args: ['prevRedesignButton', { static: false, read: ElementRef }]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(DealsCarouselComponent, { className: "DealsCarouselComponent", filePath: "deals-carousel/deals-carousel.component.ts", lineNumber: 14 }); })();

class DealsCarouselModule {
    static { this.ɵfac = function DealsCarouselModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DealsCarouselModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DealsCarouselModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            LoyaltyCardModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DealsCarouselModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DealsCarouselComponent
                ],
                imports: [
                    CommonModule,
                    LoyaltyCardModule
                ],
                exports: [
                    DealsCarouselComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(DealsCarouselModule, { declarations: [DealsCarouselComponent], imports: [CommonModule,
        LoyaltyCardModule], exports: [DealsCarouselComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DealsCarouselComponent, DealsCarouselModule };
